import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';

import { HAS_FREE_PLAN } from '@/constants/common';
import { roomTypesList } from '@/constants/roomTypes';

export const RoomTypes = () => {
  const { t } = useLocale('ai-interior');

  return (
    <div className='relative mx-auto max-w-6xl md:px-8 xl:px-0'>
      <div className='pb-16 pt-10'>
        <div className='px-4 sm:px-6 md:px-0'>
          <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
            <h2 className='text-h2 primary-600 mb-2 mt-2 text-3xl font-bold tracking-tight sm:text-4xl'>
              {t('Remodel, Redesign, or Get Ideas for Various Room Types')}
            </h2>
            <p className='mt-4 text-lg text-gray-600 dark:text-slate-300'>
              {t(
                'Discover the perfect design for every room with our AI Designer. From bathrooms to bedrooms, garages to hotel lobbies, find inspiration and create stunning interiors effortlessly.',
              )}
            </p>
          </div>
          <div className='mt-5'>
            <ul className='mt-1 grid  grid-cols-2 gap-x-5  gap-y-5 sm:grid-cols-3'>
              {roomTypesList.map((roomType) => (
                <li key={roomType.slug}>
                  <Link href={`/ai-interior-design-generator/${roomType.slug}`}>
                    <div className='relative h-[160px] w-full xl:h-[260px] '>
                      <Image
                        src={`https://media.easy-peasy.ai/room-types/${roomType.slug}.jpeg`}
                        alt={roomType.name}
                        width={300}
                        height={300}
                        className='absolute left-0 top-0 h-full w-full rounded-lg object-cover'
                      />
                    </div>
                    <div className='text-md p-1 font-semibold text-gray-600  dark:text-slate-300'>
                      {t(roomType.name) as string}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className='mb-16 sm:flex sm:justify-center'>
        <div className='rounded-md shadow'>
          <Link
            href={
              HAS_FREE_PLAN ? `/login?preset=ai-interior-designer` : '/#pricing'
            }
            className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'
          >
            {t('Try it yourself for free')}
          </Link>
        </div>
      </div>
    </div>
  );
};
